<template>
  <nav class="navbar navbar-expand-lg navbar-dark py-3" style="background-color: #353257">
    <div class="container">
      <router-link class="navbar-brand" exact-active-class="active" to="/">
        <img width="200" src="../../public/Sustenidos.png" alt="">
      </router-link>

      <!-- Botão para menu mobile -->
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto gap-lg-3 gap-1">
          <template v-if="usuario">
            <li class="nav-item">
              <span class="nav-link"><b> Olá, {{ usuario.nome }}</b></span>
            </li>

            <!-- Links para administrador -->
            <template v-if="usuario.tipo === 'admin'">
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/">
                  <i v-if="$route.path === '/'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Vagas</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/relatorios">
                  <i v-if="$route.path === '/relatorios'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Relatórios</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/admin">
                  <i v-if="$route.path === '/admin'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Painel</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/admin/usuarios">
                  <i v-if="$route.path === '/admin/usuarios'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Usuários</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/admin/nova-vaga">
                  <i v-if="$route.path === '/admin/nova-vaga'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Adicionar Nova Vaga</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/notificacoes">Notificações</router-link>
              </li>
            </template>

            <!-- Links para candidato -->
            <template v-else-if="usuario.tipo === 'candidato'">
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/">
                  <i v-if="$route.path === '/'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Vagas</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/dashboard">
                  <i v-if="$route.path === '/dashboard'" class="bi bi-check-circle-fill me-2 text-light"></i>
                  <span>Minha Área</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/notificacoes">Notificações</router-link>
              </li>
            </template>

            <li class="nav-item">
              <a class="nav-link" href="#" @click.prevent="logout">Sair</a>
            </li>
          </template>

          <template v-else>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/">
                <i v-if="$route.path === '/'" class="bi bi-check-circle-fill me-2 text-light"></i>
                <span>Vagas</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/login">
                <i v-if="$route.path === '/login'" class="bi bi-check-circle-fill me-2 text-light"></i>
                <span>Login</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link d-flex align-items-center" exact-active-class="active" to="/register">
                <i v-if="$route.path === '/register'" class="bi bi-check-circle-fill me-2 text-light"></i>
                <span>Cadastro</span>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import auth from '../store/auth';

export default {
  name: "HeaderVie",
  computed: {
    usuario() {
      return auth.usuario;
    }
  },
  methods: {
    logout() {
      auth.logout();
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.navbar-nav .nav-link {
  white-space: nowrap;
}
@media (max-width: 991.98px) {
  .navbar-nav {
    gap: 0.5rem !important;
  }
  .navbar-brand img {
    width: 150px !important;
  }
}
</style>

